"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../../common/js/helper/translation");
const Tooltip_1 = __importDefault(require("../../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../../enums/TooltipPosition"));
const AssetsSoftwareContactNameColumn = (0, mobx_react_1.observer)((props) => {
    const { license } = props;
    return (react_1.default.createElement("div", { "data-tag": "allowRowEvents", className: (0, classnames_1.default)('--white-space-normal', 'my-2', { 'znd-table-tile__info': license.deletedContact }) },
        react_1.default.createElement("span", { className: "znd-table-tile__name znd-table-tile__name--with-icon" }, license.licenseContactName),
        license.deletedContact ? (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.bottomCenter, label: (0, translation_1.t)('myassets.software.table.deleted_contact'), className: "align-self-center" },
            react_1.default.createElement("span", { className: "znd-table-tile__icon-info" }, "!"))) : null));
});
exports.default = AssetsSoftwareContactNameColumn;
